import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const TableWrapper = styled.div`
  width: 100%;
  border: 0.0625rem solid ${Theme.colors.G_3};
  border-radius: 0.625rem;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: center;
`;

export const Thead = styled.thead`
  background-color: ${Theme.colors.G_6};
  border-bottom: 0.125rem solid ${Theme.colors.G_5};
`;

export const Tr = styled.tr`
  border-bottom: 0.0625rem solid ${Theme.colors.G_3};
  
  &:hover {
    background-color: ${Theme.colors.G_6};
  }
`;

export const Th = styled.th`
  padding: 1rem 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: ${Theme.colors.BLACK};
  white-space: nowrap;
`;

export const Tbody = styled.tbody`
  background-color: ${Theme.colors.WHITE};
`;

export const Td = styled.td`
  padding: 1rem 0.75rem;
  font-size: 0.9375rem;
  color: ${Theme.colors.BLACK};
  white-space: nowrap;
`;

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 0.25rem;
  background-color: ${({ color }) => color};
  color: ${Theme.colors.WHITE};
  font-size: 0.875rem;
  font-weight: 500;
`;

